import React, { useState } from 'react';
import Header from './navbar.js';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../css/resetPassword.css';
import { useDispatch, useSelector } from 'react-redux';
import { resetPasswordWithToken } from '../store/Slices/authSlice.js';
import toast, { Toaster } from 'react-hot-toast';
import LoadingScreen from '../skeletons/loadingSkeleton.jsx';

const ResetPasswordWithToken = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const loading = useSelector((state) => state.auth.loading);

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const token = new URLSearchParams(location.search).get('token');

    const validatePassword = (password) => {
        // const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
        return passwordRegex.test(password);
    };

    const handleNewPasswordChange = (e) => {
        const value = e.target.value;

        setNewPassword(value);

        if (!validatePassword(value)) {
            setError(
                'Password must be at least 8 characters long, contain at least one capital letter, one digit, and one special character'
            );
            return;
        }

        if (confirmPassword && confirmPassword !== value) {
            setError('Passwords do not match');
            return;
        }

        setError('');
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;

        setConfirmPassword(value);

        if (value !== newPassword) {
            setError('Passwords do not match');
        } else if (!validatePassword(newPassword)) {
            setError(
                'Password must be at least 8 characters long, contain at least one capital letter and one digit, and contain only letters and digits'
            );
        } else {
            setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!token) {
            setError('Invalid or expired password reset link');
            return;
        }

        if (!validatePassword(newPassword)) {
            setError(
                'Password must be at least 8 characters long, contain at least one capital letter and one digit, and contain only letters and digits'
            );
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        const data = {
            token: token,
            new_password: newPassword
        };

        dispatch(resetPasswordWithToken(data)).then((response) => {
            if (
                response?.payload?.message ===
                'Password reset successful'
            ) {
                toast.success('Password reset successfully');

                setTimeout(() => {
                    navigate('/');
                }, 1500);
            } else {
                setError(
                    response?.error?.message ||
                    'Invalid or expired password reset link'
                );
            }
        });
    };

    return (
        <div>
            <Header />

            <Toaster
                position="top-center"
                reverseOrder={false}
            />

            {loading ? (
                <LoadingScreen />
            ) : (
                <div className="reset-password-container">

                    <form
                        onSubmit={handleSubmit}
                        className="reset-password-box"
                    >
                        <div>
                            <h1
                                style={{
                                    color: '#f16e00',
                                    fontWeight: 'bold'
                                }}
                            >
                                Reset Password
                            </h1>

                            <br />
                        </div>

                        {!token && (
                            <span>
                                Invalid or expired password reset link
                            </span>
                        )}

                        <div>
                            <label>New Password:</label>

                            <input
                                type="password"
                                value={newPassword}
                                onChange={handleNewPasswordChange}
                                placeholder="New password"
                            />
                        </div>

                        <div>
                            <label>Confirm Password:</label>

                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                placeholder="Confirm password"
                            />
                        </div>

                        {error && (
                            <span>{error}</span>
                        )}

                        <div className="login-link">
                            <Link to="/">
                                Back to Login
                            </Link>
                        </div>

                        <button
                            type="submit"
                            disabled={
                                !token ||
                                error !== '' ||
                                !newPassword ||
                                !confirmPassword
                            }
                        >
                            Reset Password
                        </button>
                    </form>

                </div>
            )}
        </div>
    );
};

export default ResetPasswordWithToken;